import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid2';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { alpha, useTheme } from '@mui/material/styles';

import Image from 'src/components/image';
import { bgGradient } from 'src/theme/css';

import Iconify from 'src/components/iconify';
import React from 'react';
import { brand } from '../../templates/shared-theme/themePrimitives';
import Divider from '@mui/material/Divider';
import { fShortenNumber } from '../../theme/format-number';

// ----------------------------------------------------------------------

const ROWS = [
  {
    label: 'Certified Trainers',
    total: 100,
  },
  {
    label: 'Gym Partners',
    total: 10,
  },
  {
    label: 'Years of Experience',
    total: 15,
  },
];

export default function HomeDarkAds() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        ...bgGradient({
          color: alpha(theme.palette.grey[900], 0.78),
          imgUrl: '/assets/images/home/trainers.png',
        }),
        textAlign: 'center',
        color: 'common.white',
        py: { xs: 20, md: 27 },
      }}
    >
      {/*<Typography variant="h2" sx={{ mt: 2, mb: 5 }}>*/}
      {/*  MEET THE STRONGER, HEALTHIER YOU!*/}
      {/*  </Typography>*/}

      <Grid size={12}>
        <Stack
          spacing={5}
          direction={{ xs: 'column', md: 'row' }}
          sx={{
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {ROWS.map((row) => (
            <Stack
              key={row.label}
              direction="row"
              alignItems="center"
              width={300}
              divider={
                <Divider
                  flexItem
                  orientation="vertical"
                  sx={{ ml: 3, mr: 5, borderStyle: 'dashed' }}
                />
              }
            >
              <Stack spacing={1} sx={{ width: 300 }} alignItems="center">
                <Stack direction="row">
                  <Typography variant="h1" >{fShortenNumber(row.total)}</Typography>
                  <Box component="span" sx={{ color: brand[200], typography: 'h2' }}>
                    +
                  </Box>
                </Stack>

                <Typography sx={{ color: 'white', fontSize: '1.5rem' }}>
                  {row.label}
                </Typography>
              </Stack>
            </Stack>
          ))}
        </Stack>
      </Grid>

      <Box sx={{ my: 15 }} />

      <Button
        href="/profiles"
        color="inherit"
        sx={{
          backgroundColor: brand[300],
          color: 'white',
          padding: '30px 20px',
          '&:hover': {
            backgroundColor: brand[200],
          },
        }}
      >
        <Typography sx={{ paddingX: 2, paddingY: 1, fontSize: '2rem', fontWeight: 'bold' }}>
          View Our Trainers
        </Typography>
      </Button>
    </Box>
  );
}
